/*
 * @Descripttion:
 * @version:
 * @Author: qiangXiong
 * @Date: 2021-08-11 20:04:13
 * @LastEditors: qiangXiong
 * @LastEditTime: 2021-08-13 09:31:37
 */
import Vue from "vue";
import VueRouter from "vue-router";

import "../assets/css/global.less";

Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title: '首页'
    },
    redirect: '/user_agreement'
  },
  {
    path: "/user_agreement",
    name: "user_agreement",
    meta: {
      title: "用户协议",
    },
    component: () => import("../views/userAgreement.vue"), // 用户协议
  },
  //   privacy_policy
  {
    path: "/privacy_policy",
    name: "privacy_policy",
    meta: {
      title: "隐私政策",
    },
    component: () => import("../views/privacyPolicy.vue"), // 隐私政策
  },
  {
    path: "/sdk_note",
    name: "sdk_note",
    meta: {
      title: "第三方sdk说明",
    },
    component: () => import("../views/sdkNote.vue"), // 第三方sdk说明
  },
  {
    path: "/vipService",
    name: "vipService",
    meta: {
      title: "会员服务协议",
    },
    component: () => import("../views/vipService.vue"), // 隐私政策
  },
  // //   contract_note
  {
    path: "/contract_note",
    name: "contract_note",
    meta: {
      title: "合同说明",
    },
    component: () => import("../views/contractNote.vue"), // 合同说明
  },
];

const router = new VueRouter({
  routes,
});

export default router;
